/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateCouponPaymentOptions,
  CreateCouponPaymentStatus201,
  CreateCouponPaymentStatus400,
  CreateCouponPaymentStatus500,
} from '../types/CreateCouponPayment'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createCouponPayment } from '../clients/createCouponPayment'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createCouponPaymentMutationKey = () =>
  [{ url: '/v1/assets/:asset_id/coupon_payments' }] as const

export function createCouponPaymentMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createCouponPaymentMutationKey()
  return mutationOptions<
    CreateCouponPaymentStatus201,
    ResponseErrorConfig<CreateCouponPaymentStatus400 | CreateCouponPaymentStatus500>,
    CreateCouponPaymentOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return createCouponPayment({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a coupon payment for a bond asset
 * @deprecated
 * {@link /v1/assets/:asset_id/coupon_payments}
 */
export function useCreateCouponPayment<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateCouponPaymentStatus201,
      ResponseErrorConfig<CreateCouponPaymentStatus400 | CreateCouponPaymentStatus500>,
      CreateCouponPaymentOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createCouponPaymentMutationKey()

  const baseOptions = createCouponPaymentMutationOptions(config) as UseMutationOptions<
    CreateCouponPaymentStatus201,
    ResponseErrorConfig<CreateCouponPaymentStatus400 | CreateCouponPaymentStatus500>,
    CreateCouponPaymentOptions,
    TContext
  >

  return useMutation<
    CreateCouponPaymentStatus201,
    ResponseErrorConfig<CreateCouponPaymentStatus400 | CreateCouponPaymentStatus500>,
    CreateCouponPaymentOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateCouponPaymentStatus201,
    ResponseErrorConfig<CreateCouponPaymentStatus400 | CreateCouponPaymentStatus500>,
    CreateCouponPaymentOptions,
    TContext
  >
}
